import { useCallback, useEffect, useState } from "react";

export const SEARCH_DEBOUNCE_MS = 300;

export function useDebouncedValue<Value>(value: Value, delay = SEARCH_DEBOUNCE_MS): Value {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timer);
  }, [delay, value]);

  return debounced;
}

export function useDebouncedSearch(initialValue = "", delay = SEARCH_DEBOUNCE_MS) {
  const [input, setInput] = useState(initialValue);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const timer = window.setTimeout(() => setValue(input), delay);
    return () => window.clearTimeout(timer);
  }, [delay, input]);

  const reset = useCallback((nextValue = "") => {
    setInput(nextValue);
    setValue(nextValue);
  }, []);

  return { input, reset, setInput, value };
}
